<template>
  <div>
    <h2 :class="isMobile?'mx-2':'mx-8'">{{title.plural}}</h2>
    <v-row class="align-center" :class="isMobile?'':'mx-3'">
      <v-col cols="2" class="d-flex align-center pb-0">
        <v-tooltip location="top">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              variant="plain"
              class="square-btn"
              icon
              @click="openFilters"
              v-if="currentView === 'table' || currentView === 'calendar' "
            >
              <v-icon>mdi mdi-filter</v-icon>
            </v-btn>
          </template>
          Filtros
        </v-tooltip>

        <v-tooltip location="top">
          <template #activator="{ props }">
            <v-btn
              v-bind="props"
              variant="plain"
              class="square-btn"
              icon
              @click="openPreferences"
            >
              <v-icon>mdi mdi-cog</v-icon>
            </v-btn>
          </template>
          Preferencias
        </v-tooltip>
      </v-col>

      <v-col cols="5" class="d-flex align-center pb-0 px-6" v-if="currentView == 'grid' || currentView == 'card'">
        Ordenar por:
        <v-autocomplete
          v-model="sortBy"
          :items="sortableHeaders"
          item-title="title"
          item-value="value"
          density="compact"
          style="max-width: 200px;"
          class="mx-4"
          hide-details
          variant="outlined"
        />
        <v-btn
          variant="plain"
          @click="direction === 'asc' ? (direction = 'desc') : (direction = 'asc')"
          density="compact"
          style="min-width: 0px;"
          class="px-0"
        >
          <v-icon v-if="direction === 'asc'">mdi-arrow-up</v-icon>
          <v-icon v-else>mdi-arrow-down</v-icon>
        </v-btn>
      </v-col>

      <v-col cols="5" class="ml-auto d-flex justify-end pb-0">
        <v-btn class="mr-6 mt-2" v-if="!isMobile" @click="openCreateForm">Crear {{title.singular}}</v-btn>
        <v-btn-toggle
          mandatory
          v-model="currentView"
          color="primary"
          variant="text"
          v-if="filteredViewModes.length>1"
        >
          <v-tooltip
            v-for="mode in filteredViewModes"
            :key="mode.value"
            location="top"
          >
            <template #activator="{ props: tooltipProps }">
              <v-btn
                v-bind="tooltipProps"
                class="square-btn ma-2"
                icon
                :value="mode.value"
              >
                <v-icon>{{ mode.icon }}</v-icon>
              </v-btn>
            </template>
            {{ mode.label }}
          </v-tooltip>
        </v-btn-toggle>
      </v-col>

      <v-btn v-if="isMobile" icon class="fab-btn" @click="openCreateForm">
        <v-icon color="white">mdi-plus</v-icon>
      </v-btn>

    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, computed } from 'vue';
import { useRightDrawerStore } from '@/store/rightDrawer';
import { useFloatFormStore } from '@/store/floatForm';
import { ViewModes, ViewModeOptions } from '@/enums/viewModes';
import { useLayoutField } from '@/composables/useLayoutField';
import { useDisplay } from 'vuetify';

export default defineComponent({
  name: 'Toolbar',
  props: {
    moduleName: {
      type: String,
      required: true,
    },
    sortableHeaders: Array,
    config:String,
    onCreate: {
      type: Function as PropType<(data: Record<string, any>) => Promise<any>>,
      required: false,
    },
    title: Object,
      availableViews: {
      type: Array as PropType<string[]>,
      required: false,
      default: () => ['table', 'grid', 'card'], // fallback por si no se pasa
    },
  },
  setup(props) {

    const { mobile } = useDisplay();
    const isMobile = computed(() => mobile.value);

    const moduleName = props.moduleName

    const currentView = useLayoutField(moduleName, 'currentView');
    const sortBy = useLayoutField(moduleName, 'sortBy');
    const direction = useLayoutField(moduleName, 'direction');

    const { openDrawer } = useRightDrawerStore();

    const { openForm } = useFloatFormStore();

    const openFilters = () => {
      openDrawer({
        config:props.config,
        component: 'Filters',
        drawerTitle: 'Filtros',
        drawerWidth: '400',
      });
    };

    const openPreferences = () => {
      openDrawer({
        module: moduleName,
        component: 'Preferences',
        drawerTitle: 'Preferencias',
        drawerWidth: '400',
      });
    };

    const openCreateForm = () => {
      openForm({
        component: 'CreateForm',
        formTitle: 'Crear ' + props.title?.singular,
        formWidth: '1080',
        module: moduleName,
        props: {
          onCreate: props.onCreate,
        }
      });
    }

    const filteredViewModes = computed(() =>
      ViewModeOptions.filter((mode) => props.availableViews.includes(mode.value))
    );

    return {
      currentView,
      sortBy,
      direction,
      openFilters,
      openPreferences,
      openCreateForm,
      ViewModes,
      filteredViewModes,
      moduleName,
      isMobile
    };
  },
});
</script>
<style scoped>
.fab-btn {
  position: fixed;
  bottom: 24px;
  right: 24px;
  border-radius: 50%;
  z-index: 10;
  width: 56px;
  height: 56px;
}
</style>